import { Component, OnInit, Input, EventEmitter, Output, Injector } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ContainerService, ContainerTypeService, ContainerSourceService, AttachmentService } from '../../../../phf.service';
import { Subject, BehaviorSubject } from 'rxjs';
import { PartDetailService } from '../part-detail.service';
import { S3Service } from '../../../../../../shared/services/s3.service';
import { FilterableService } from '../../../../../mesc/filterable-service';
import { PartListService } from '../../part-list.service';
import { AuthenticationService } from '../../../../../../auth.service';
import { takeUntil } from 'rxjs/operators';


@Component({
  selector: 'container-tab',
  templateUrl: './container-tab.component.html',
  styleUrls: ['../part-detail.component.scss']
})
export class ContainerTabComponent implements OnInit {
  part: any;
  editForm: FormGroup;
  loadSide: any
  isEditing: boolean;
  isLoading = false;
  clickImg: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  showStyleWindow: boolean;
  sideService: FilterableService;
  containerTypeService: FilterableService;
  containerSourceService: FilterableService;
  private readonly ngUnsubscribe: Subject<void> = new Subject<void>();
  private readonly formBuilder: FormBuilder;
  private readonly containerService: ContainerService;
  public readonly messageService: PartDetailService;
  private readonly s3Service: S3Service;
  private readonly attachmentService: AttachmentService;
  private readonly partListService: PartListService;
  public readonly authService: AuthenticationService;

  @Input()
  set data(dataItem: any) {
    if (dataItem) {
      this.part = dataItem;
    }
  }

  @Output()
  updateEditForm: EventEmitter<FormGroup> = new EventEmitter();

  constructor(private readonly injector: Injector) {
    this.showStyleWindow = false;
    this.formBuilder = injector.get(FormBuilder);
    this.containerService = injector.get(ContainerService);
    this.messageService = injector.get(PartDetailService);
    this.s3Service = injector.get(S3Service);
    this.attachmentService = injector.get(AttachmentService);
    this.partListService = this.injector.get(PartListService);
    this.authService = injector.get(AuthenticationService);

    this.messageService.getMessage()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(message => {
        this.isEditing = message.editing;
      });
  }

  ngOnInit() {
    this.editForm = this.formBuilder.group(ContainerEditForm);
    this.messageService.containerDataObject = this.editForm; // Sets pointer from messageService container to this formGroup

    this.sideService = this.partListService.lookupData.SideViewDto;
    this.containerTypeService = this.partListService.lookupData.ContainerTypeViewDto;
    this.containerSourceService = this.partListService.lookupData.ContainerSourceViewDto;
    this.getContainer();
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  get canEditManualDunnage(): boolean {
    return this.authService?.isPHFUser
      || this.authService?.isPHFSystemAdmin
      || this.authService?.isPHFUserAdmin
      || this.authService?.isPHFProgramAdmin;
  }

  onKeyUp = (e) => {
    if (isNaN(e.target.valueAsNumber)) {
      try {
        e.target.value = parseInt(e.target.value);
      } catch (e) {
        e.target.value = '';
      }
    }
  }

  /**
  * Calls Container API and passes container object to other API's for reference
  */
  private getContainer() {
    if (this.part.Id) {
      this.containerService.read('/part/' + this.part.Id)
        .then(containerResult => this.updateEditform(containerResult))
    }
    else { this.isLoading = false; }
  }

  private updateEditform(containerResult: any) {
    {
      if (containerResult) {
        this.editForm.reset(containerResult);
        if (this.editForm.get('ContainerTypeId').value) {
          this.handleTypeChange(this.editForm.get('ContainerTypeId').value)
        }
        if (this.editForm.get('ContainerSourceId').value) {
          this.handleSourceChange(this.editForm.get('ContainerSourceId').value)
        }
        if (this.editForm.get('LoadSideId').value) {
          this.handleSideChange(this.editForm.get('LoadSideId').value)
        }
        if (containerResult.AttachmentId) {
          this.attachmentService.read('/' + containerResult.AttachmentId)
            .then(response => {
              if (response) {
                const filePath = 'PHF/ContainerPictures/' + response.FileName;
                const url = this.s3Service.getS3Path(filePath)
                this.editForm.get('Attachment').setValue(url);
              }
            })
        }
      }
      this.isLoading = false;
    }
  }

  handleTypeChange = (dataItem) => {
    const type = this.containerTypeService.value.find(x => x.Id === dataItem);
    this.editForm.get('ContainerType').setValue(type ? type.Name : '');
    this.editForm.get('ContainerTypeId').setValue(type ? type.Id : '');

  }

  handleSourceChange = (dataItem) => {
    const source = this.containerSourceService.value.find(x => x.Id === dataItem);
    this.editForm.get('ContainerSourceName').setValue(source ? source.Name : '');
    this.editForm.get('ContainerSourceId').setValue(source ? source.Id : '');

  }

  handleSideChange = (dataItem) => {
    const side = this.sideService.value.find(x => x.Id === dataItem);
    this.editForm.get('LoadSide').setValue(side ? side.Name : '');
    this.editForm.get('LoadSideId').setValue(side ? side.Id : '');

  }

  updateStyleData(dataItem: any) {
    this.showStyleWindow = false;
    this.editForm.get('Style').setValue(dataItem);
    this.updateEditForm.emit(this.editForm);
  }

  closeStyleWindow() {
    this.showStyleWindow = false;
  }

  onEditStyleClick() {
    this.showStyleWindow = true;
  }

  isImgOpen = () => {
    return this.clickImg.value;
  }

  openImg = () => {
    this.clickImg.next(true);
  }

  closeImg = () => {
    this.clickImg.next(false);
  }
}

const ContainerEditForm = {
  ContainerSourceId: [],
  ContainerTypeId: [],
  Height: [],
  ImageTeamcenterURL: [],
  IsActive: [],
  Length: [],
  LoadSideId: [],
  ManualDunnage: [],
  Number: [],
  PartsPerContainer: [],
  Style: [],
  Width: [],
  Name: [],
  ContainerSourceName: [],
  ContainerType: [],
  LoadSide: [],
  Id: [],
  Attachment: [],
  AttachmentId: [],
  AttachmentFileInfo: [],
  Deviations: [],
  PartId: [],
}
